import PageLoader from "components/PageLoader"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  BaseHeaderLayout,
  Box,
  ContentLayout,
  Flex,
  IconButton,
  LinkButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Typography,
} from "@strapi/design-system"
import { Code, Cog, Paint, Pencil, Plus, Eye } from "@strapi/icons"
import { useMerchantsQuery } from "hooks/query/useMerchantQuery.ts"

export const MerchantsPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: merchants = [], isLoading } = useMerchantsQuery()

  return (
    <Box>
      <BaseHeaderLayout
        title={t("merchantsPage.title")}
        as={"h1"}
        primaryAction={
          <LinkButton startIcon={<Plus />} target="_self" href={`/merchants/add`}>
            {t("merchantsPage.addMerchant")}
          </LinkButton>
        }
        subtitle={t("merchantsPage.subtitle", { count: merchants.length })}
      />
      {!!merchants.length && (
        <ContentLayout>
          <Table>
            <Thead>
              <Tr>
                <Th>{t("merchantsPage.name")}</Th>
                <Th>{t("merchantsPage.email")}</Th>
                <Th>{t("merchantsPage.domain")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {merchants.map((merchant) => (
                <Tr key={merchant.id}>
                  <Td>
                    <Typography textColor="neutral800">{merchant.name}</Typography>
                  </Td>
                  <Td>{merchant.email}</Td>
                  <Td>{merchant.domain}</Td>
                  <Td>
                    <Flex gap={2}>
                      <IconButton
                        onClick={() => navigate(`/merchants/edit?id=${merchant.id}`)}
                        label={t("merchantsPage.edit")}
                        icon={<Pencil />}
                      />
                      <IconButton
                        onClick={() => navigate(`/ui-customization/edit?id=${merchant.id}`)}
                        label={t("merchantsPage.uiCustomization")}
                        icon={<Paint />}
                      />
                      <IconButton
                        onClick={() => navigate(`/configuration?id=${merchant.id}`)}
                        label={t("merchantsPage.configuration")}
                        icon={<Cog />}
                      />
                      <IconButton
                        onClick={() => navigate(`/integration-info?id=${merchant.id}`)}
                        label={t("merchantsPage.integration")}
                        icon={<Code />}
                      />
                      <IconButton
                        onClick={() => navigate(`/analytics?id=${merchant.id}`)}
                        label={t("merchantsPage.analytics")}
                        icon={<Eye />}
                      />
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ContentLayout>
      )}
      {isLoading && <PageLoader />}
    </Box>
  )
}
